'use client';

import { useIntl } from 'react-intl';
import { StaticErrorContent } from '@packages/modules/src/StaticErrorContent/StaticErrorContent.client';

export const PreviewNotFound = () => {
  const { formatMessage } = useIntl();
  return (
    <StaticErrorContent
      title={formatMessage({
        id: 'previewapp.404.title',
        defaultMessage: '404 - PAGE OR REVISION NOT FOUND',
      })}
      description={formatMessage({
        id: 'previewapp.404.description',
        defaultMessage: 'The desired page or revision could not be found.',
      })}
    />
  );
};
